import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getProvider, ServiceProvider } from '../../api/ProviderService';
import { StoreState } from '../../store/store';

export const fetchProvider = createAsyncThunk<
  ServiceProvider,
  undefined,
  { state: StoreState }
>('provider/fetchProvider', async () => {
  const data = await getProvider();
  return data;
});

export interface ProviderState {
  objectUUID: string;
  features: ServiceProvider['features'];
}

const initialState: ProviderState = {
  objectUUID: '',
  features: {},
};

export const selectProviderFeatures = (state: StoreState) =>
  state.provider.features;

const { reducer } = createSlice({
  name: 'provider',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchProvider.pending, state => state);
    builder.addCase(fetchProvider.rejected, state => state);
    builder.addCase(fetchProvider.fulfilled, (state, action) => {
      state.objectUUID = action.payload?.objectUUID ?? undefined;
      if (state.objectUUID) {
        state.features = action.payload?.features ?? {};
        if (!state.features.ui || !state.features.ui['useNewUI']) {
          window.location.href = `${window.location.origin}#${window.location.pathname}`;
        }
      }
    });
  },
});

export default reducer;
